import React from "react";
import "./UnlockAddons.scss";

import { useSelector } from "react-redux";
import { RootState } from "src/redux/reducers";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { useHistory } from "react-router";
import SubscriptionPageWrapper, {
  SubscriptionPageContent,
} from "../../components/SubscriptionPageWrapper/SubscriptionPageWrapper";
import { closeSubscriptionPage } from "../../subscriptionFunctions";

function UnlockAddons() {
  const { subscriptionPlan } = useSelector(
    (state: RootState) => state.subscriptionReducer,
  );
  const { identity } = useSelector((state: RootState) => state.mainReducer);

  const history = useHistory();

  return (
    <SubscriptionPageWrapper>
      <SubscriptionPageContent
        className="unlock-addons"
        width={1040}
        backButtonFunction={() =>
          closeSubscriptionPage(history, identity.lastWorkspaceUuid)
        }
        backButtonText={
          <IDHFormattedMessage
            id="ws_back_to_application"
            defaultMessage="Back to application"
          />
        }
      >
        No unlock addons screen available
        {/* <Button
          className="change-plan-button"
          size="large"
          variant="white-with-light-grey-border"
          onClick={() => openSelectPlanScreen(history, activeWorkspaceUuid)}
        >
          <EditIcon />
          <IDHFormattedMessage
            id="ws_change_plan"
            defaultMessage="Change plan"
          />
        </Button> */}
      </SubscriptionPageContent>
    </SubscriptionPageWrapper>
  );
}

export default UnlockAddons;
